import React from "react";
import { ContactAreaMap } from "../../components/ContactAreas/ContactAreaMap";
const links = ["General Support", "Logistics", "Privacy Queries", "Website"];

export const ContactAreaInner = () => {
  return (
    <section className="inner-contact-area pt-120 pb-100">
      <div className="container">
        <div className="row align-items-center g-2">
          <div className="col-lg-6 order-2 order-lg-1">
            <ContactAreaMap />
          </div>

          <div className="col-lg-6 order-1 order-lg-2">
            <div className="inner-contact-info">
              <h2 className="title">Our Office Address</h2>
              <div className="contact-info-item">
                <ul className="list-wrap">
                  <li>
                    <span style={{ fontWeight: "bold" }}>
                      Kadle Global Pvt Ltd
                    </span>{" "}
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      Registered Office :
                    </span>{" "}
                    #429-B/1, Congress Road, Tilakwadi, Belgaum. Karnataka. PIN:
                    590006
                  </li>
                  {links.map((link, i) => (
                    <li>
                      <h6>
                        {link}:{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                          }}
                        >
                          <a
                            href={
                              link === "Website"
                                ? "https://kadleglobal.com"
                                : "mailto:hi@kadleglobal.com"
                            }
                          >
                            {link === "Website"
                              ? "https://kadleglobal.com"
                              : "hi@kadleglobal.com"}
                          </a>
                        </span>
                      </h6>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
